import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firebaseConfig';
import { ref, get, remove } from 'firebase/database';
import { useAuth } from '../../context/AuthContext';
import { logAdminAction } from '../../firebase/auditLogger';

function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userProfile } = useAuth();

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const msgRef = ref(db, 'contactMessages');
      const snapshot = await get(msgRef);
      if (snapshot.exists()) {
        const msgObj = snapshot.val();
        const msgList = Object.keys(msgObj).map(key => ({
          mid: key,
          ...msgObj[key]
        }));
        setMessages(msgList.reverse()); // latest first
      } else {
        setMessages([]);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (mid) => {
    if (window.confirm("Resolve and delete this ticket?")) {
      try {
        await remove(ref(db, `contactMessages/${mid}`));
        logAdminAction(userProfile?.adminId, "Resolved and Closed User Support Message Ticket", mid);
        fetchMessages();
      } catch (error) {
        alert("Error resolving message: " + error.message);
      }
    }
  };

  return (
    <div className="animate-up">
      <div className="admin-page-header">
        <h1>Contact Messages</h1>
        <p>Support tickets sent from the public website.</p>
      </div>

      <div className="admin-card">
        {loading ? (
          <div style={{padding: '40px', textAlign: 'center', color: '#8b949e'}}>Loading inbox...</div>
        ) : (
          <div className="admin-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>From</th>
                  <th>Message Body</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {messages.length === 0 ? (
                  <tr><td colSpan="4" style={{textAlign: 'center', padding: '30px', color: '#8b949e'}}>Inbox is empty!</td></tr>
                ) : (
                  messages.map(msg => (
                    <tr key={msg.mid}>
                      <td style={{color: '#8b949e', fontSize: '0.85rem'}}>
                        {msg.createdAt ? new Date(msg.createdAt).toLocaleString() : 'Unknown'}
                      </td>
                      <td>
                        <div style={{color: '#fff', fontWeight: '500'}}>{msg.name}</div>
                        <div style={{color: '#00ffae', fontSize: '0.85rem'}}>{msg.email}</div>
                      </td>
                      <td style={{maxWidth: '400px', paddingRight: '30px'}}>
                        <p style={{margin: 0, color: '#c9d1d9', lineHeight: '1.5', whiteSpace: 'pre-wrap'}}>{msg.message}</p>
                      </td>
                      <td>
                        <button onClick={() => handleDelete(msg.mid)} style={{color: '#a5b4fc', cursor: 'pointer', background: 'rgba(165,180,252,0.1)', padding: '6px 15px', borderRadius: '6px', border: 'none', fontWeight: 'bold'}}>
                          <i className="fa-solid fa-check"></i> Resolve
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminMessages;
